module.exports = __webpack_public_path__ + "static/BNI-black-42e113c884d81dbb06bfcceeeed69701.svg";